function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.iterator.js";
import React, { Fragment } from 'react';
import { ParagraphSmall } from '@finect/tabular-core/Paragraph';
import { getProductTypeById, getProductTypeLabel } from '@finect/front-resources/Products';
import { Section } from '../../Section';
import { ClassesModal } from '../../Modules/ClassesModal';
import { ProductDistributor } from './ProductDistributor';
import { FeaturedProductDistributor } from './FeaturedProductDistributor';
import { getUserBankByOrganizationAlias } from './utils';
import { Organizations, FeaturedOrganizations, OrganizationContainer, OtherAction, ClaimBlock } from './partials';
var uniqueBy = function uniqueBy(arr) {
  var seen = new Map();
  return arr.filter(function (item) {
    return seen.has(item.organization.id) ? false : seen.set(item.organization.id, item);
  });
};
var getOrderPremiumDistributor = function getOrderPremiumDistributor(comm) {
  return comm.organization.facts.filter(function (item) {
    return item !== 'premium-distributor';
  }).find(function (item) {
    return item.indexOf('premium-') === 0;
  }) || 'premium-99999';
};
export var FundDistributors = function (_React$Component) {
  _inherits(FundDistributors, _React$Component);
  var _super = _createSuper(FundDistributors);
  function FundDistributors() {
    var _this;
    _classCallCheck(this, FundDistributors);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      classesModalOpen: false
    });
    _defineProperty(_assertThisInitialized(_this), "handleFeaturedAction", function (featCommercialization) {
      var _this$props = _this.props,
        onProductRequest = _this$props.onProductRequest,
        _this$props$userBanks = _this$props.userBanks,
        userBanks = _this$props$userBanks === void 0 ? [] : _this$props$userBanks;
      var featUserBank = getUserBankByOrganizationAlias(userBanks, featCommercialization.organization.alias);
      var flow = featUserBank ? 'subscription' : 'account';
      onProductRequest(featCommercialization, flow);
    });
    _defineProperty(_assertThisInitialized(_this), "handleSecondaryAction", function (featCommercialization) {
      var _this$props2 = _this.props,
        _this$props2$banks = _this$props2.banks,
        banks = _this$props2$banks === void 0 ? [] : _this$props2$banks,
        onProductRequest = _this$props2.onProductRequest;
      if (banks.find(function (bank) {
        return bank.organization && bank.organization.id === featCommercialization.organization.id;
      })) {
        window.location.href = 'https://www.finect.com/tus-inversiones/bancos/agregar';
        return;
      }
      onProductRequest(featCommercialization, 'link');
    });
    _defineProperty(_assertThisInitialized(_this), "handleOpenModal", function () {
      _this.setState({
        classesModalOpen: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleCloseModal", function () {
      _this.setState({
        classesModalOpen: false
      });
    });
    return _this;
  }
  _createClass(FundDistributors, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props3 = this.props,
        product = _this$props3.product,
        fund = _this$props3.fund,
        banks = _this$props3.banks,
        _this$props3$userBank = _this$props3.userBanks,
        userBanks = _this$props3$userBank === void 0 ? [] : _this$props3$userBank,
        userBankState = _this$props3.userBankState,
        onProductRequest = _this$props3.onProductRequest,
        isPartner = _this$props3.isPartner;
      if (!product || !product.entity) return null;
      var productType = getProductTypeById(product.subtype);
      var featCommercializations = uniqueBy(product.entity.commercializations.filter(function (comm) {
        return comm.id && comm.affiliate && comm.affiliate.name;
      }).filter(function (comm) {
        return comm.organization.facts && comm.organization.facts.includes('premium-distributor');
      }));
      featCommercializations.sort(function (_a, _b) {
        return getOrderPremiumDistributor(_a) < getOrderPremiumDistributor(_b) ? -1 : 1;
      });
      var distributors = product.entity.commercializations.filter(function (comm) {
        return comm.id && comm.affiliate && comm.affiliate.name;
      }).filter(function (comm) {
        return !comm.organization.facts || !comm.organization.facts.includes('premium-distributor');
      }).filter(function (comm) {
        return comm.security && comm.security.id === fund.class.id;
      });
      var uniqueDistributorIds = distributors.map(function (item) {
        return item.organization.id;
      }).filter(function (value, index, self) {
        return self.indexOf(value) === index;
      });
      var uniqueDistributors = uniqueDistributorIds.map(function (id) {
        return distributors.find(function (item) {
          return item.organization.id === id;
        });
      });
      var distributorsWithoutClass = product.entity.commercializations.filter(function (comm) {
        return comm.id && comm.affiliate && comm.affiliate.name;
      }).filter(function (comm) {
        return comm.security && comm.security.id !== fund.class.id;
      });
      var uniqueDistributorIdsWithoutClass = distributorsWithoutClass.map(function (item) {
        return item.organization.id;
      }).filter(function (value, index, self) {
        return self.indexOf(value) === index;
      });
      var uniqueDistributorsWithoutClass = uniqueDistributorIdsWithoutClass.map(function (id) {
        return distributorsWithoutClass.find(function (item) {
          return item.organization.id === id;
        });
      });
      if (!distributors.length && !distributorsWithoutClass.length && featCommercializations.length === 0) return null;
      return React.createElement(Fragment, null, React.createElement(ClassesModal, {
        onClose: this.handleCloseModal,
        show: this.state.classesModalOpen,
        fund: product.entity
      }), React.createElement(Section, {
        title: "\xBFD\xF3nde contratar este ".concat(getProductTypeLabel(productType, 'shortSingular', 'lowercase'), "?"),
        bottomMargin: Boolean(distributors.length) || Boolean(featCommercializations)
      }, React.createElement(ClaimBlock, null, React.createElement(ParagraphSmall, null, "Desde Finect te recomendamos comparar siempre entre distintas entidades antes de contratar fondos, planes, ETFs y otros productos financieros.")), React.createElement(FeaturedOrganizations, {
        items: featCommercializations.length
      }, featCommercializations.length > 0 && featCommercializations.map(function (fC, index) {
        return React.createElement(FeaturedProductDistributor, {
          isPartner: isPartner,
          totalCards: featCommercializations.length,
          key: index,
          product: product,
          commercialization: fC,
          onAction: function onAction() {
            return _this2.handleFeaturedAction(fC);
          },
          onSecondaryAction: function onSecondaryAction() {
            return _this2.handleSecondaryAction(fC);
          },
          userBank: getUserBankByOrganizationAlias(userBanks, fC.organization.alias),
          userBankState: userBankState
        });
      })), uniqueDistributors.length > 0 && React.createElement(React.Fragment, null, React.createElement(ParagraphSmall, null, "\xC9ste tambi\xE9n puedes encontrarlo en nuestro", uniqueDistributors.length > 1 ? 's' : '', " distribudor", uniqueDistributors.length > 1 ? 'es' : '', " patrocinado", uniqueDistributors.length > 1 ? 's' : '', ":"), React.createElement(Organizations, null, uniqueDistributors.map(function (item) {
        return React.createElement(OrganizationContainer, {
          key: item.id
        }, React.createElement(ProductDistributor, {
          isPartner: isPartner,
          product: product,
          commercialization: item,
          userBank: getUserBankByOrganizationAlias(userBanks, item.organization.alias),
          entity: item.organization,
          onAction: function onAction() {
            onProductRequest(item, null, null);
          },
          userBankState: userBankState,
          banks: banks
        }));
      })))), uniqueDistributorsWithoutClass.length ? React.createElement(Section, {
        bottomMargin: true
      }, React.createElement(ParagraphSmall, null, "Puedes contratar ", React.createElement(OtherAction, {
        onClick: function onClick() {
          return _this2.handleOpenModal();
        }
      }, "otras clases"), " de este", ' ', getProductTypeLabel(productType, 'shortSingular', 'lowercase'), " en", ' ', uniqueDistributorsWithoutClass.map(function (item, index) {
        return React.createElement(Fragment, {
          key: item.id
        }, React.createElement(OtherAction, {
          onClick: function onClick() {
            onProductRequest(null, null, null);
          }
        }, item.organization.displayName), index === uniqueDistributorsWithoutClass.length - 1 ? '' : ', ');
      }))) : null);
    }
  }]);
  return FundDistributors;
}(React.Component);